<script>
import appConfig from '@src/app.config';
import Layout from '@layouts/main';
import PageHeader from '@components/page-header';

import PageViewsChart from './PageViewsChart';
import PageViewsGrouped from './PageViewsGrouped';


export default {
  page: {
    title: 'Page Views',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, PageViewsChart, PageViewsGrouped },
  data() {
    return {
      title: 'Page Views',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Page Views', active: true, },
      ],

    }
  },
  created() {

  },
  mounted() {
    window.addEventListener('scroll', this.setStickyNav);
    window.addEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').addEventListener('scroll', this.setStickyNav); }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.setStickyNav);
    window.removeEventListener('resize', this.setStickyNav);
    if(document.querySelector('.table-responsive')) { document.querySelector('.table-responsive').removeEventListener('scroll', this.setStickyNav); }
  },
  methods: {

  }
}
</script>

<template>
  <Layout>
    <router-view v-show="$route.params.id"></router-view>

    <div v-show="!$route.params.id">

      <PageHeader :title="title" :items="items" />

      <div class="row mt-4">
				<div class="col-12">
          <page-views-chart></page-views-chart>
				</div>
        <div class="col-12">
          <page-views-grouped></page-views-grouped>
        </div>
      </div>

    </div>
  </Layout>
</template>
